// @ts-nocheck
import { TabProps } from "@insite/mobius/Tab";
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const tab: Styleguide["tab"] = {
    defaultProps: {
        typographyProps: {
            forwardAs: "h3",
            css: css`
                font-size: ${x => x.theme.design.typography.size.smaller};
            `,
        },
        css: css<TabProps>`
            ${focusStyles(true)}
            cursor: pointer;
            border-bottom: ${pxToRem(2)} solid ${getColor("common.border")};
            transition: ${transitionHoverStyles("color", "border-color")};
            ${breakpointValues([pxToRem(6, 10), pxToRem(8, 15), pxToRem(10, 20), null, pxToRem(12, 30)], "padding")}

            &:hover, &[aria-selected="true"] {
                border-bottom: ${pxToRem(2)} solid ${getColor("primary")};
                color: ${getColor("primary")};
            }
        `,
    },
    groupDefaultProps: {
        cssOverrides: {
            wrapper: css`
                padding: 0;

                > div /* contents wrapper */ {
                    width: 100%;
                }
            `,
            tabContent: css`
                border: none;
                padding: 0;
                ${breakpointValues(pxToRemArray([26, 30, 36, null, 50]), "margin-top")}
            `,
            tabGroup: css`
                flex-wrap: wrap;
                justify-content: center;
                padding: 0;
            `,
        },
    },
};

export default tab;
